import React from 'react';
import moment from 'moment';
import WithTooltip from '../../../webcommon/common/formcomponents/customvalidation/ComponentWithTooltip';
import WebJobsStatus from '../DataLoads/customgridcomponents/Status';
import ClickableLink from './customgridcomponents/ClickableLink';
import Message from '../DataLoads/customgridcomponents/Message';
import * as appConstants from '../../../common/constants';

const MessageWithTooltip = WithTooltip(Message);

const mappings = [
    {
        id: 'source',
        title: 'Source'
    },
    {
        id: 'category',
        title: 'Category'
    },
    {
        id: 'businessDate',
        title: 'Date',
        type: 'date',
        filterMethod: (filter, row) => moment(row.businessDate).format(appConstants.dateFormat).includes(filter.value),
        renderCell: row => moment(row.original.businessDate).format(appConstants.dateFormat) || ''
    },
    {
        id: 'timestamp',
        title: 'Timestamp',
        type: 'date',
        filterMethod: (filter, row) => moment(row.timestamp).format(appConstants.dateTimeFormat).includes(filter.value),
        renderCell: row => moment(row.original.timestamp).format(appConstants.dateTimeFormat) || ''
    },
    {
        id: 'destination',
        title: 'Destination',
        renderCell: row => <ClickableLink value={ row.value } />
    },
    {
        id: 'errorMessage',
        title: 'Message',
        renderCell: row => <MessageWithTooltip value={ row.value } tooltipMessage={ row.value || '' } placement="top" showTooltip />
    },
    {
        id: 'status',
        title: 'Status',
        renderCell: row => (
            <WebJobsStatus
                id={ row.original.requestId }
                setDetailsBeingViewed={ row.column.getGridProps().setDetailsBeingViewed }
                showIcons={ false }
                status={ row.value }
            />
        )
    }
];

export default mappings;
